module.exports = __webpack_public_path__ + "img/warehousing.04adfbb7.svg";